import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRightLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.5 23L17.5 12L6.5 1"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgRightLarge.displayName = 'SvgRightLarge';
const RightLarge = withForgeIconProps(SvgRightLarge, {
  name: 'Right',
  usage: 'Use to go to the next page or item.',
  related: 'forward, navigation',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default RightLarge;
